<!--多文件上传-->
<template>
  <el-upload
    ref="upload"
    :data="data"
    :action="action"
    :headers="headers"
    :file-list="filelist"
    :on-preview="handlePreview"
    :before-remove="handleBeforeRemove"
    :on-exceed="handleExceed"
    v-bind="$attrs"
    id="myuploader"
  >
    <slot name="trigger" />
    <slot name="tip" />
  </el-upload>
</template>

<script>
export default {
  name: "multipleUpload",
  props: {
    data: { type: Object },
  },
  data() {
    return {
      action: `${process.env.VUE_APP_API}/api/System/File/Upload`,
      filelist: [],
      headers: {
        Authorization: `Bearer ${this.$utils.cookies.get("token")}`,
        "X-Authorization": `Bearer ${this.$utils.cookies.get("refresh_token")}`,
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    //已上传文件列表
    initData() {
      this.$apis.system.file
        .list({
          objectId: this.data.ObjectId,
          mode: this.data?.Mode,
        })
        .then((res) => {
          this.filelist = res;
        });
    },
    //删除文件前
    handleBeforeRemove(file) {
      if (file.id) {
        return this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          type: "warning",
          center: true,
        }).then(() => {
          this.$apis.system.file.delete({ id: file.id });
        });
      }
    },
    handleExceed() {
      this.$message.error("已超出文件上传数量限制");
    },
    handlePreview(file) {
      file.url && window.open(file.url);
    },
    //按钮提交上传
    onSubmit(id = null) {
      if (id) {
        this.data.ObjectId = id;
      }
      if (this.data.ObjectId) {
        this.$refs["upload"].submit();
      } else {
        this.$message.error("缺少ObjectID参数");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#myuploader[disabled] {
  :deep(.el-upload) {
    display: none;
    &-list__item:first-child {
      margin-top: 0;
    }
  }
}
</style>
